import { locale } from '../../Services/Tools/reducers';
import Logo from './LogoNevidis';

const dashboard = {
  timer: {
    isEnable: true,
    interval: 100000
  },
  strings: locale('fr', 'dashboard'),
  logo: [{
    name: 'nevidis',
    componemt: Logo,
    default: true,
  }],
  defaultWidgets: [
    {
      component: 'DlpkDashboardCard',
      position: 2,
      config: {
        title: 'Nouvelle Tarification',
        icon: 'euro',
        label: 'Cliquez ici',
        link: '/quotations/new'
      }
    },
    {
      component: 'DlpkContactCard',
      position: 3,
      conditions: [{
        code: 'theme',
        operator: '=',
        value: 'nortia',
      }],
      config: {
        title: "Besoin d'aide ?",
        emailContact: 'service.partenaire@nortia-protect.fr',
        phoneContact: '01 87 66 84 31',
        // scheduleContact: 'Lun. au .Ven. de 08h à 19h',
        scheduleContact: '',
        extras: [
          {
            label: 'Découvrez votre Portail NORTIA PROTECT',
            url: 'https://view.genial.ly/5dfc93797c54700fa8f328e9/interactive-image-image-interactive',
          },
        ],
      }
    },
    {
      component: 'DlpkContactCard',
      position: 4,
      conditions: [{
        code: 'theme',
        operator: '=',
        value: 'nevidis',
      }],
      config: {
        title: "Besoin d'aide ?",
        emailContact: 'service.partenaire@nevidis.fr',
        phoneContact: '01 87 66 84 31',
        // scheduleContact: 'Lun. au .Ven. de 08h à 19h',
        scheduleContact: '',
      }
    }
  ],
  widgets: []
};

export default dashboard;
